import { VideoWidgetState } from './types'

const state = (): VideoWidgetState => ({
  progress: 0,
})

export default state
